import { useEffect, useState } from 'react';

import dateFormat from 'dateformat';
import { Fragment } from 'react';
import { Form } from 'react-bootstrap';

import { UserCommissionRepository } from '../../MedicareProAPI/Repositories/User/UserCommissionRepository';
import { UserCommissionScheduleBandRepository } from '../../MedicareProAPI/Repositories/User/UserCommissionScheduleBandRepository';
import { UserCommissionScheduleRepository } from '../../MedicareProAPI/Repositories/User/UserCommissionScheduleRepository';
import { Utilities } from '../../MedicareProAPI/Utilities/Utilities';
import { useSchedules } from '../Context/SchedulesContext';
import CommissionClone from './CommissionClone';
import StyledModal from './StyledModal';

export default function CommissionSingle(props) {
  const { schedulesByPlanId, updateSchedules } = useSchedules();
  const [statesModal, setStatesModal] = useState(null);
  const [policyEffectiveDatesEnabled, setPolicyEffectiveDatesEnabled] = useState({});
  const [schedulesExpanded, setSchedulesExpanded] = useState(false);
  const [agesEnabled, setAgesEnabled] = useState({});
  const [, forceUpdate] = useState(0);

  const [commissionData, setCommissionData] = useState(null);
  const [commissionDataSaving, setCommissionDataSaving] = useState(false);

  const userCommissionRepository = new UserCommissionRepository();
  userCommissionRepository.setAccessToken(props.userAccessToken);

  const userCommissionScheduleRepository = new UserCommissionScheduleRepository();
  userCommissionScheduleRepository.setAccessToken(props.userAccessToken);

  const userCommissionScheduleBandRepository = new UserCommissionScheduleBandRepository();
  userCommissionScheduleBandRepository.setAccessToken(props.userAccessToken);

  const ipValue = 1000000;
  const states = Utilities.getStates();
  const ageRange = Utilities.getRange(56, 45);
  const getAdvance = [
    { value: 1, label: 'AE' },
    { value: 1, label: '1 m' },
    { value: 2, label: '2 m' },
    { value: 3, label: '3 m' },
    { value: 4, label: '4 m' },
    { value: 5, label: '5 m' },
    { value: 6, label: '6 m' },
    { value: 7, label: '7 m' },
    { value: 8, label: '8 m' },
    { value: 9, label: '9 m' },
    { value: 10, label: '10 m' },
    { value: 11, label: '11 m' },
    { value: 12, label: '12 m' },
  ];

  const getMaxLives = [
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' },
    { value: 7, label: '7' },
    { value: 8, label: '8' },
    { value: 9, label: '9' },
    { value: 10, label: '10' },
    { value: 11, label: '11' },
    { value: 12, label: '12' },
    { value: 100, label: 'NA' },
  ];

  const getCalculateOnOptions = [
    { value: 'total', label: 'Total Premium' },
    { value: 'member', label: 'Member Premium' },
    { value: 'commissionable', label: 'Commissionable Premium' },
  ];

  const getWrittenAs = [
    { value: null, label: 'None' },
    { value: 'AOR Change', label: 'AOR Change' },
  ];

  const toggleSchedulesExpanded = () => {
    setSchedulesExpanded(!schedulesExpanded);
  };

  const getDefaultSchedule = () => {
    let schedule = {
      name: null,
      type: 'percentage',
      advance: 3,
      states: null,
      ageMin: null,
      ageMax: null,
      dateMin: null,
      dateMax: null,
      bands: [
        {
          value: 13,
          yearMin: 0,
          yearMax: 1,
        },
      ],
    };

    return schedule;
  };

  // Get Commission
  useEffect(() => {
    userCommissionRepository
      .getUserCommission(
        props.userId,
        props.policy.getCompany().getCompanyId(),
        props.policy.getPlan().getPlanId(),
        { include: ['schedules', 'bands'] }
      )
      .then((commission) => {
        const _commissionData = {
          schedules: [],
          planId: null,
        };

        if (commission) {
          updateSchedules(commission.getPlan().getPlanId(), commission.getSchedules());
          _commissionData['id'] = commission.getId();
          _commissionData['planId'] = commission.getPlan().getPlanId();

          commission
            .getSchedules()
            .getItems()
            .forEach((schedule, scheduleIndex) => {
              let scheduleData = {
                id: schedule.getId(),
                type: schedule.getType(),
                name: schedule.getName(),
                advance: schedule.getAdvance(),
                states: schedule.getStates(),
                ageMin: schedule.getAgeMin(),
                ageMax: schedule.getAgeMax(),
                dateMin: schedule.getDateMin(),
                dateMax: schedule.getDateMax(),
                livesMax: schedule.getLivesMax(),
                writtenAs: schedule.getWrittenAs(),
                calculateOn: schedule.getCalculateOn(),
                bands: [],
              };

              if (schedule.getDateMin() || schedule.getDateMax()) {
                handlePolicyEffectiveDatesChange(scheduleIndex, true);
              }

              schedule
                .getBands()
                .getItems()
                .forEach((band) => {
                  scheduleData.bands.push({
                    value: band.getValue(),
                    yearMin: band.getYearMin(),
                    yearMax: band.getYearMax(),
                  });
                });

              if (scheduleData.bands.length === 0) {
                scheduleData.bands.push({
                  value: 13,
                  yearMin: 0,
                  yearMax: 1,
                });
              }

              if (schedule.getAgeMin() || schedule.getAgeMax()) {
                handleScheduleAgesChange(scheduleIndex, true);
              }

              _commissionData.schedules.push(scheduleData);
            });
        }

        setCommissionData(_commissionData);
      });
  }, []);

  const handlePolicyEffectiveDatesChange = (scheduleIndex, value) => {
    let newPolicyEffectiveDatesEnabled = { ...policyEffectiveDatesEnabled, [scheduleIndex]: value };

    setPolicyEffectiveDatesEnabled(newPolicyEffectiveDatesEnabled);
  };

  const handleScheduleAgesChange = (scheduleIndex, value) => {
    let newAgesEnabled = { ...agesEnabled, [scheduleIndex]: value };

    setAgesEnabled(newAgesEnabled);
  };

  const handleScheduleDataChange =
    (fieldName, scheduleIndex, overrideValue = undefined) =>
    (event) => {
      let updatedCommissionData = { ...commissionData };
      let value = overrideValue === undefined ? event.target.value : overrideValue;

      if (event.target.type === 'checkbox' && fieldName === 'states') {
        let values = updatedCommissionData['schedules'][scheduleIndex][fieldName];

        if (event.target.checked) {
          if (values) {
            values.push(value);
          } else {
            values = [value];
          }
        } else if (values) {
          let valueIndex = values.indexOf(value);
          if (valueIndex > -1) {
            values.splice(valueIndex, 1);
          }

          if (values.length === 0) {
            values = null;
          }
        }

        value = values;
      } else if (fieldName === 'writtenAs' && event.target.value == '') {
        value = null;
      } else if (fieldName === 'calculateOn' && event.target.value == '') {
        value = null;
      } else if (event.target.type === 'checkbox') {
        /*else if( event.target.type === 'date' )
          {
              value = value ? Utilities.dateStringToDate(value) : null;
              value = value ? Utilities.dateStringToDate(value) : null;
          }*/
        value = event.target.checked;
      }

      updatedCommissionData['schedules'][scheduleIndex][fieldName] = value;

      setCommissionData(updatedCommissionData);
    };

  const handleBandDataChange = (fieldName, scheduleIndex, bandIndex) => (event) => {
    let updatedCommissionData = { ...commissionData };

    updatedCommissionData['schedules'][scheduleIndex]['bands'][bandIndex][fieldName] =
      event.target.value;

    updatedCommissionData['schedules'][scheduleIndex]['bands'] = handleBandDataSanitize(
      updatedCommissionData['schedules'][scheduleIndex]['bands']
    );

    setCommissionData(updatedCommissionData);
  };

  const handleBandDataSanitize = (scheduleBandData) => {
    scheduleBandData.forEach((_bandData, bandIndex) => {
      let prevBandData = scheduleBandData[bandIndex - 1];
      let nextBandData = scheduleBandData[bandIndex + 1];
      let bandData = scheduleBandData[bandIndex];

      if (prevBandData && prevBandData.yearMax + 1 !== bandData.yearMin) {
        scheduleBandData[bandIndex - 1].yearMax = parseInt(bandData.yearMin) - 1;
      }

      if (nextBandData && nextBandData.yearMin - 1 !== bandData.yearMax) {
        scheduleBandData[bandIndex + 1].yearMin = parseInt(bandData.yearMax) + 1;

        if (scheduleBandData[bandIndex + 1].yearMax <= scheduleBandData[bandIndex + 1].yearMin) {
          scheduleBandData[bandIndex + 1].yearMax =
            parseInt(scheduleBandData[bandIndex + 1].yearMin) + 1;
        }
      }
    });

    return scheduleBandData;
  };

  const handleBandDataRemove = (scheduleIndex, bandIndex) => (event) => {
    let updatedCommissionData = { ...commissionData };

    updatedCommissionData['schedules'][scheduleIndex]['bands'].splice(bandIndex, 1);

    updatedCommissionData['schedules'][scheduleIndex]['bands'] = handleBandDataSanitize(
      updatedCommissionData['schedules'][scheduleIndex]['bands']
    );

    setCommissionData(updatedCommissionData);
  };

  const handleScheduleDataRemove = (scheduleIndex) => (event) => {
    let updatedCommissionData = { ...commissionData };

    let selectedSchedule = updatedCommissionData['schedules'][scheduleIndex];

    if (commissionData.id && selectedSchedule.id) {
      userCommissionScheduleRepository
        .removeUserCommissionSchedule(props.userId, commissionData.id, selectedSchedule.id)
        .then((response) => {
          handleDispatch();
        });
    }

    updatedCommissionData['schedules'].splice(scheduleIndex, 1);

    setCommissionData(updatedCommissionData);
  };

  const handleBandDataAdd = (scheduleIndex) => (event) => {
    let updatedCommissionData = { ...commissionData };

    let lastBandReference =
      updatedCommissionData['schedules'][scheduleIndex]['bands'][
        updatedCommissionData['schedules'][scheduleIndex]['bands'].length - 1
      ];
    let lastBand = {
      ...updatedCommissionData['schedules'][scheduleIndex]['bands'][
        updatedCommissionData['schedules'][scheduleIndex]['bands'].length - 1
      ],
    };

    // If the previous band "Max Year" was IP when make sure the old value is switched
    if (lastBand.yearMax === ipValue) {
      lastBandReference.yearMax = parseInt(lastBand.yearMin) + 1;
      lastBand.yearMax = ipValue;
    } else {
      //lastBand.yearMax = lastBand.yearMin + 1;
      lastBand.yearMax = parseInt(lastBand.yearMax) + 2;
    }

    lastBand.previousYearEnd = lastBandReference.yearMax;
    lastBand.yearMin = parseInt(lastBandReference.yearMax) + 1;
    lastBand.value = null;

    updatedCommissionData['schedules'][scheduleIndex]['bands'].push(lastBand);

    setCommissionData(updatedCommissionData);
  };

  const handleScheduleDataAdd = () => (event) => {
    setSchedulesExpanded(true);

    let updatedCommissionData = { ...commissionData };

    updatedCommissionData['schedules'].push(getDefaultSchedule());

    setCommissionData(updatedCommissionData);
  };

  const handleCommissionSave = async () => {
    setCommissionDataSaving(true);

    if (!commissionData.id) {
      let newCommission = await userCommissionRepository.createUserCommission(props.userId, {
        company: props.policy.getCompany().getCompanyId(),
        plan: props.policy.getPlan().getPlanId(),
      });

      commissionData.id = newCommission.getId();
    }

    for (const schedule of commissionData.schedules) {
      var scheduleData = {
        type: schedule.type,
        name: schedule.name,
        advance: schedule.advance,
        states: schedule.states,
        ageMin: schedule.ageMin,
        ageMax: schedule.ageMax,
        dateMin: schedule.dateMin,
        dateMax: schedule.dateMax,
        livesMax: schedule.livesMax,
        writtenAs: schedule.writtenAs,
        calculateOn: schedule.calculateOn,
      };

      if (!schedule.id) {
        let newSchedule = await userCommissionScheduleRepository.createUserCommissionSchedule(
          props.userId,
          commissionData.id,
          scheduleData
        );

        schedule.id = newSchedule.getId();
      } else {
        let updatedSchedule = await userCommissionScheduleRepository.updateUserCommissionSchedule(
          props.userId,
          commissionData.id,
          schedule.id,
          scheduleData
        );
      }

      await userCommissionScheduleBandRepository.removeUserCommissionScheduleBands(
        props.userId,
        commissionData.id,
        schedule.id
      );

      let position = 0;

      for (const band of schedule.bands) {
        if (band.value) {
          await userCommissionScheduleBandRepository.createUserCommissionScheduleBand(
            props.userId,
            commissionData.id,
            schedule.id,
            {
              position: position,
              yearMin: band.yearMin,
              yearMax: band.yearMax,
              value: parseFloat(band.value),
            }
          );
        }

        position++;
      }
    }

    setCommissionDataSaving(false);

    handleDispatch();
  };

  const handleDispatch = () => {
    // Lets vanilla js script know to refresh commissions (pending page)
    if (props.dispatchOnUpsert) {
      const event = new CustomEvent('commissionUpdated', {
        detail: { timestamp: Date.now() },
      });
      window.dispatchEvent(event);
    }

    if (props.onSave) {
      props.onSave();
    }
  };

  const handleCloneCommission = (planId, sourceScheduleId, destinationScheduleIndex) => {
    const source = schedulesByPlanId[planId].items.find(
      (schedule) => schedule.id === sourceScheduleId
    );
    if (source) {
      Object.keys(source).forEach((key) => {
        const value = source[key];
        switch (key) {
          case 'id':
            break;
          case 'name':
            break;
          case 'bands':
            commissionData.schedules[destinationScheduleIndex][key] = value.items.map(
              ({ value, yearMin, yearMax }) => ({
                value,
                yearMin,
                yearMax,
              })
            );
            break;
          case 'dateMin':
          case 'dateMax':
            if (source[key]) {
              commissionData.schedules[destinationScheduleIndex][key] = new Date(source[key]);
            }
            break;

          default:
            commissionData.schedules[destinationScheduleIndex][key] =
              value && typeof value === 'object'
                ? JSON.parse(JSON.stringify(value)) // deep clone for objects
                : value;
        }
      });
      handleScheduleAgesChange(destinationScheduleIndex, source.ageMin || source.ageMax);
      handlePolicyEffectiveDatesChange(destinationScheduleIndex, source.dateMin || source.dateMax);

      forceUpdate((prev) => prev + 1);
    }
  };

  return (
    <div
      className={
        'card drugCard mb-3 pb-0 calMess' +
        (commissionData && commissionData.schedules && commissionData.schedules.length > 0
          ? 'border-success'
          : 'border-warning')
      }
    >
      {commissionData && (
        <div
          className={
            'col-12 font-weight-bold pt-2 ' +
            (commissionData && schedulesExpanded && commissionData.schedules.length > 0
              ? 'mb-3 border-bottom pb-2'
              : 'pb-3')
          }
          sx={{ fontSize: '11pt' }}
        >
          <div>{props.policy.getPlan().getPlanName()}</div>{' '}
          {commissionData.schedules && commissionData.schedules.length ? (
            <small
              className="badge badge-primary"
              onClick={(e) => toggleSchedulesExpanded(props.policy.getPlan().getPlanId())}
            >
              {schedulesExpanded ? 'Collapse' : 'Expand'} {commissionData.schedules.length}{' '}
              Schedules
            </small>
          ) : (
            <>
              <small className="badge badge-secondary">No Schedules Created</small>
            </>
          )}{' '}
          <small className="badge badge-success" onClick={handleScheduleDataAdd()}>
            <i className={'fas fa-plus-circle mr-1'}></i>Add Schedule
          </small>
        </div>
      )}

      <div className="pl-3 pr-3">
        {!commissionData && (
          <div className="alert small alert-info mt-2" role="alert">
            <i className="fas fa-spinner fa-spin ml-2"></i> Loading....
          </div>
        )}
        {/*
                ( commissionData && ( commissionData.schedules.length === 0 )  ) &&
                    <div className="alert small alert-info mt-1" role="alert">Information about addding schedules</div>
        */}
        {commissionData &&
          schedulesExpanded &&
          commissionData.schedules.map((schedule, scheduleIndex) => {
            return (
              <>
                <StyledModal
                  size="lg"
                  title="States"
                  footerCloseButton={true}
                  show={statesModal === scheduleIndex}
                  onClose={(e) => setStatesModal(null)}
                >
                  <div className="row states pl-1 pr-1">
                    {states.map((state) => {
                      let containerClassList = [
                        'p-1',
                        'pl-4',
                        'form-check',
                        'w-100',
                        'rounded',
                        'border',
                        'border-primary',
                      ];

                      let checked =
                        schedule.states &&
                        Array.isArray(schedule.states) &&
                        schedule.states.includes(state.abbreviation)
                          ? true
                          : false;

                      if (checked) {
                        containerClassList.push('bg-primary');
                        containerClassList.push('text-light');
                      } else {
                        containerClassList.push('text-primary');
                      }

                      let elementId =
                        props.policy.getCompany().getCompanyId() +
                        '-' +
                        props.policy.getPlan().getPlanId() +
                        '-' +
                        scheduleIndex +
                        '-' +
                        state.abbreviation;

                      return (
                        <div key={elementId} className="col-3 p-1">
                          <div className={containerClassList.join(' ')}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={elementId}
                              checked={checked ? 'checked' : ''}
                              value={state.abbreviation}
                              name="states"
                              onChange={handleScheduleDataChange('states', scheduleIndex)}
                            />
                            <label className="form-check-label w-100" htmlFor={elementId}>
                              <small>{state.name}</small>
                            </label>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </StyledModal>
                <div
                  className={'card mb-3 p-2 ' + (schedule.id ? 'border-success' : 'border-warning')}
                >
                  <div className="d-flex mb-3  pb-1 border-bottom align-items-center ">
                    <div className="flex-grow-1 mr-2">
                      <input
                        onChange={handleScheduleDataChange('name', scheduleIndex)}
                        value={schedule.name}
                        placeholder="Memorable name for this schedule"
                        type="text"
                        className="w-100 form-control border-secondary"
                      />
                    </div>
                    <CommissionClone
                      options={{
                        planId: commissionData.planId,
                        scheduleIndex: scheduleIndex,
                        policyGroup: props.policyGroup,
                      }}
                      onCloneCommission={handleCloneCommission}
                    />
                  </div>
                  <div className="row p-2">
                    {/* Type */}
                    <div className="col-xxxl-2 col-xxl-2 col-sm-6 mb-3 border-bottom pb-2">
                      <label className="form-check-label label font-weight-bold">Type</label>
                      <div className="pl-4">
                        <input
                          onChange={handleScheduleDataChange('type', scheduleIndex)}
                          checked={schedule.type === 'percentage' ? 'checked' : ''}
                          name={`type_${props.policy.getPlan().getPlanId()}${scheduleIndex}`}
                          className="form-check-input"
                          type="radio"
                          value="percentage"
                          autoComplete="off"
                        />
                        <label className="form-check-label label">Percentage</label>
                      </div>
                      <div className="pl-4">
                        <input
                          onChange={handleScheduleDataChange('type', scheduleIndex)}
                          checked={schedule.type === 'fixed' ? 'checked' : ''}
                          name={`type_${props.policy.getPlan().getPlanId()}${scheduleIndex}`}
                          className="form-check-input"
                          type="radio"
                          value="fixed"
                          autoComplete="off"
                        />
                        <label className="form-check-label label">Fixed Rate</label>
                      </div>
                    </div>

                    {/* Advance */}
                    <div className="col-xxxl-1 col-xxl-2 col-sm-6 text-left mb-3 border-bottom pb-2 border-left">
                      <label className="form-check-label label font-weight-bold">Advance</label>
                      <select
                        value={schedule.advance}
                        onChange={handleScheduleDataChange('advance', scheduleIndex)}
                        className="form-control form-control-sm border-secondary"
                        sx={{ width: 'auto' }}
                      >
                        {getAdvance.map((advance) => (
                          <option
                            key={`advance-${advance.value}-${advance.label}`}
                            value={advance.value}
                          >
                            {advance.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* States */}
                    <div className=" col-xxxl-2 col-xxl-4 col-sm-6 text-left mb-3 border-bottom pb-2 border-left">
                      <label className="form-check-label label font-weight-bold">States</label>
                      <div>
                        {states
                          .filter(
                            (state) =>
                              schedule.states &&
                              Array.isArray(schedule.states) &&
                              schedule.states.includes(state.abbreviation)
                          )
                          .map((state) => (
                            <>
                              <span key={state.name} className="badge badge-secondary">
                                {state.name}
                              </span>{' '}
                            </>
                          ))}
                        {(!schedule.states || schedule.states.length === 0) && (
                          <span className="badge badge-secondary">All states</span>
                        )}
                      </div>
                      <button
                        onClick={(e) => setStatesModal(scheduleIndex)}
                        className="mt-1 btn btn-outline-primary btn-sm"
                      >
                        Edit
                      </button>
                    </div>

                    {/* Age Range */}
                    <div className="col-xxxl-1 col-xxl-4 col-sm-6 text-left mb-3 border-bottom pb-2 border-left">
                      <label className="form-check-label label font-weight-bold">Age Range</label>
                      {agesEnabled[scheduleIndex] ? (
                        <>
                          <div className="year-range">
                            <select
                              value={schedule.ageMin}
                              onChange={handleScheduleDataChange('ageMin', scheduleIndex)}
                              className="form-control form-control-sm border-secondary w-auto d-inline-block"
                            >
                              <option></option>
                              {ageRange.map((age) => (
                                <option key={`min-${scheduleIndex}-${age}`} value={age}>
                                  {age}
                                </option>
                              ))}
                            </select>
                            <> -</>
                            <select
                              value={schedule.ageMax}
                              onChange={handleScheduleDataChange('ageMax', scheduleIndex)}
                              className="form-control form-control-sm border-secondary w-auto d-inline-block"
                            >
                              <option></option>
                              {ageRange.map((age) => (
                                <option key={`max-${scheduleIndex}-${age}`} value={age}>
                                  {age}
                                </option>
                              ))}
                            </select>
                          </div>
                          <button
                            onClick={(e) => {
                              handleScheduleAgesChange(scheduleIndex, false);
                              handleScheduleDataChange('ageMin', scheduleIndex, null)(e);
                              handleScheduleDataChange('ageMax', scheduleIndex, null)(e);
                            }}
                            className="mt-1 btn btn-outline-danger btn-sm"
                          >
                            Remove
                          </button>
                        </>
                      ) : (
                        <>
                          <div>
                            <span className="badge badge-secondary">All ages</span>
                          </div>
                          <button
                            onClick={(e) => {
                              handleScheduleAgesChange(scheduleIndex, true);
                            }}
                            className="mt-1 btn btn-outline-primary btn-sm"
                          >
                            Edit
                          </button>
                        </>
                      )}
                    </div>

                    {/* Date Range */}
                    <div className="col-xxxl-3 col-xxl-4 col-sm-6 text-left mb-3 border-bottom pb-2 border-left">
                      <label className="form-check-label label font-weight-bold">
                        Policy Effective Date Range
                      </label>

                      {policyEffectiveDatesEnabled[scheduleIndex] ? (
                        <>
                          <div className="date-range">
                            <div className="date d-inline-block">
                              <Form.Control
                                type="date"
                                value={
                                  schedule.dateMin
                                    ? dateFormat(schedule.dateMin, 'yyyy-mm-dd')
                                    : null
                                }
                                onChange={handleScheduleDataChange('dateMin', scheduleIndex)}
                              />
                            </div>
                            <> -</>
                            <div className="date d-inline-block">
                              <Form.Control
                                type="date"
                                value={
                                  schedule.dateMax
                                    ? dateFormat(schedule.dateMax, 'yyyy-mm-dd')
                                    : null
                                }
                                onChange={handleScheduleDataChange('dateMax', scheduleIndex)}
                              />
                            </div>
                          </div>
                          <button
                            onClick={(e) => {
                              handlePolicyEffectiveDatesChange(scheduleIndex, false);
                              handleScheduleDataChange('dateMin', scheduleIndex, null)(e);
                              handleScheduleDataChange('dateMax', scheduleIndex, null)(e);
                            }}
                            className="mt-1 btn btn-outline-danger btn-sm"
                          >
                            Remove
                          </button>
                        </>
                      ) : (
                        <>
                          <div>
                            <span className="badge badge-secondary">All dates</span>
                          </div>
                          <button
                            onClick={(e) => handlePolicyEffectiveDatesChange(scheduleIndex, true)}
                            className="mt-1 btn btn-outline-primary btn-sm"
                          >
                            Edit
                          </button>
                        </>
                      )}
                    </div>

                    {/* Bands */}
                    <div className="col-xxxl-3 col-xxl-4 col-sm-6 text-left mb-3 border-bottom pb-2 border-left">
                      <label className="form-check-label label font-weight-bold">Ranges</label>
                      <div className="row text-left bands">
                        {schedule.bands.map((band, bandIndex) => (
                          <Fragment key={`bandFrag-${scheduleIndex}-${bandIndex}`}>
                            <div data-band-label className="col-6 text-left mb-1">
                              {bandIndex === 0 && <>Year 1</>}

                              {bandIndex !== 0 && (
                                <>
                                  <span>Year {band.yearMin}</span>
                                  <> -</>
                                  <select
                                    value={schedule.bands[bandIndex].yearMax}
                                    className="border-secondary form-control form-control-sm d-inline-block w-auto"
                                    onChange={handleBandDataChange(
                                      'yearMax',
                                      scheduleIndex,
                                      bandIndex
                                    )}
                                  >
                                    {Utilities.getRange(20, band.yearMin + 1).map((year) => (
                                      <option
                                        key={`bandMain-${scheduleIndex}-${bandIndex}`}
                                        value={year}
                                      >
                                        {year}
                                      </option>
                                    ))}
                                    <option value="1000000">IP</option>
                                  </select>
                                </>
                              )}
                            </div>

                            <div data-band-value className="col-4 text-left mb-1">
                              <div className="input-group input-group-sm">
                                {schedule.type === 'fixed' && (
                                  <div className="input-group-prepend input-group-sm">
                                    <div className="input-group-text">$</div>
                                  </div>
                                )}
                                <input
                                  onChange={handleBandDataChange('value', scheduleIndex, bandIndex)}
                                  value={band.value || ''}
                                  type="number"
                                  className="form-control form-control-sm border-secondary"
                                />
                                {schedule.type === 'percentage' && (
                                  <div className="input-group-append">
                                    <div className="input-group-text">%</div>
                                  </div>
                                )}
                              </div>
                            </div>
                            {bandIndex !== 0 && (
                              <div className="col-2 text-left mb-1 pl-0">
                                <button
                                  className="btn btn btn-outline-danger btn-sm"
                                  onClick={handleBandDataRemove(scheduleIndex, bandIndex)}
                                >
                                  x
                                </button>
                              </div>
                            )}
                          </Fragment>
                        ))}

                        <div className="col-6 text-left"></div>
                        <div className="col-6 text-left">
                          <button
                            disabled={
                              !(
                                schedule.bands &&
                                schedule.bands[schedule.bands.length - 1] &&
                                schedule.bands[schedule.bands.length - 1].yearMax &&
                                schedule.bands[schedule.bands.length - 1].value
                              )
                            }
                            className="btn btn btn-outline-success btn-sm"
                            onClick={handleBandDataAdd(scheduleIndex)}
                          >
                            Add Band
                          </button>
                        </div>
                      </div>
                    </div>
                    {/* Max Lives */}
                    {props.policy.getPlan().getPlanType() == 'IND' && (
                      <div className="col-xxxl-1 col-xxl-2 col-sm-3 text-left mb-3 border-bottom pb-2 border-left">
                        <label className="form-check-label label font-weight-bold">Max Lives</label>
                        <select
                          value={schedule.livesMax}
                          onChange={handleScheduleDataChange('livesMax', scheduleIndex)}
                          className="form-control form-control-sm border-secondary"
                          sx={{ width: 'auto' }}
                        >
                          {getMaxLives.map((maxLive) => (
                            <option
                              key={`advance-${maxLive.value}-${maxLive.label}`}
                              value={maxLive.value}
                            >
                              {maxLive.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    {/* Written as */}
                    <div className="col-xxxl-1 col-xxl-2 col-sm-3 text-left mb-3 border-bottom pb-2 border-left">
                      <label className="form-check-label label font-weight-bold">Written As</label>
                      <select
                        value={schedule.writtenAs}
                        onChange={handleScheduleDataChange('writtenAs', scheduleIndex)}
                        className="form-control form-control-sm border-secondary"
                        sx={{ width: 'auto' }}
                      >
                        {getWrittenAs.map((writtenAs) => (
                          <option key={'writtenAs-' + writtenAs.value} value={writtenAs.value}>
                            {writtenAs.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Calculate on */}
                    {props.policy.getPolicyType() === 'IND' && schedule.type === 'percentage' && (
                      <div className="col-xxxl-1 col-xxl-2 col-sm-3 text-left mb-3 border-bottom pb-2 border-left">
                        <label className="form-check-label label font-weight-bold">
                          Calculate On
                        </label>
                        <select
                          value={schedule.calculateOn}
                          onChange={handleScheduleDataChange('calculateOn', scheduleIndex)}
                          className="form-control form-control-sm border-secondary"
                          sx={{ width: 'auto' }}
                        >
                          <option value="">Select...</option>;
                          {getCalculateOnOptions.map((calculateOn) => (
                            <option key={'calc-' + calculateOn.value} value={calculateOn.value}>
                              {calculateOn.label}
                            </option>
                          ))}
                        </select>
                        <small style={{ fontSize: '8pt' }}>*Default is Total Premium.</small>
                      </div>
                    )}
                  </div>

                  <div>
                    <button
                      onClick={handleScheduleDataRemove(scheduleIndex)}
                      className="btn btn btn-danger btn-sm"
                    >
                      Delete Schedule
                    </button>
                  </div>
                </div>
              </>
            );
          })}
        {commissionData && schedulesExpanded && commissionData.schedules.length > 0 && (
          <button onClick={handleCommissionSave} className="btn btn-success btn-sm mb-3 mr-3">
            {commissionDataSaving && (
              <>
                <i className="fas fa-spinner fa-spin"></i>{' '}
              </>
            )}
            Save
          </button>
        )}
        {/*
                    ( commissionData && schedulesExpanded ) && 
                        <button onClick={handleScheduleDataAdd()} className="btn btn-outline-success btn-sm mb-3">Add Schedule</button>
            */}
      </div>
    </div>
  );
}
